import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { articles } from "../data/articles";

export const ArticlePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return <Navigate to="/publications" replace />;
  }

  return (
    <main className="article">
      <section className="article__hero">
        <div className="article__meta">{article.date}</div>
        <h1>{article.title}</h1>
        <p className="article__excerpt">{article.excerpt}</p>
      </section>
      <section className="article__content">
        <div>
          <div className="entry-content entry--item">
            <iframe
              src={`/articles/${article.slug}.html`}
              title={article.title}
              style={{
                width: "100%",
                border: "none",
                minHeight: "800px",
              }}
              onLoad={(e) => {
                const iframe = e.target as HTMLIFrameElement;
                if (iframe.contentWindow) {
                  try {
                    const body = iframe.contentWindow.document.body;
                    const content = body.querySelector(".article__content");
                    if (content) {
                      iframe.style.height = content.scrollHeight + 100 + "px";
                    } else {
                      iframe.style.height = body.scrollHeight + 100 + "px";
                    }
                  } catch (error) {
                    console.error("Cannot access iframe content:", error);
                  }
                }
              }}
            />
          </div>
        </div>
      </section>
    </main>
  );
};
